module.exports = __webpack_public_path__ + "static/media/headerBrocast.4a1813a7.png";